export { default } from "ember-stereo/-private/utils/mime-types";
